import { render, staticRenderFns } from "./AppointmentInfo.vue?vue&type=template&id=890ba71a"
import script from "./AppointmentInfo.vue?vue&type=script&lang=js"
export * from "./AppointmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports